import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  welcome = true;

  constructor(private router: Router,
              private authService: AuthService) {
    const that = this;
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (!that.authService.isLoggedIn()) {
          that.logout();
          return;
        }
        if (val.url !== '/') {
          that.welcome = false;
        } else {
          that.welcome = true;
        }
      }
    });
  }

  ngOnInit() {
  }

  logout() {
    this.authService.logout();
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/dashboard/dashboard.component.ts